import { useTranslation } from "react-i18next";

const NoData = () => {
  const { t } = useTranslation("athlete-portal");
  return (
    <div className="composition-no-data">
      <span>{t("bodyComposition.noDataAvailable")}</span>
    </div>
  );
};
export default NoData;
